import { mapGetters } from 'vuex';
import roleResolver from '@/utilities/roleResolver';
import numbersFormats from '@/mixins/numbersFormats';

export default {
  computed: {
    ...mapGetters('auth', ['user', 'roles']),
    activeUsername() {
      const role = this.$route?.meta?.role || '';
      const resolved = roleResolver(role);
      if (resolved && resolved.username) return resolved;
      const sapId = this.user?.sap_id;
      return sapId
        ? {
            username: numbersFormats.methods.fillNumberToNDigits(sapId, 8),
            role: this.user?.roles?.[0]?.name || '',
            metaRole: role,
          }
        : null;
    },
  },
};
